import { useRef, useEffect } from 'react'

import { useGetResults } from './useGetResults'
import { useCommitResult } from './useCommitResult'
import { useSchedulingWizard } from '../../wizardContext'

export function useResultsActions() {
  const getResults = useGetResults()
  const commitResult = useCommitResult()

  const [{ loading, response }] = useSchedulingWizard()

  const showPaginationSkeleton = response === undefined

  const bodyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (loading) {
      bodyRef.current?.scrollTo(0, 0)
    }
  }, [loading])

  return {
    bodyRef,
    getResults,
    commitResult,
    showPaginationSkeleton,
  }
}
